window.toastr = require('toastr');

toastr.options = {
    closeButton: false,
    debug: false,
    positionClass: 'toast-top-full-width',
    showMethod: 'slideDown',
    showDuration: '300',
    hideDuration: '100',
    timeOut: '2500',
    preventDuplicates: true,
};



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap/toastr.js